import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers } from "vue"

import { computed, onBeforeMount, ref } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { useStore } from 'vuex';
import { AppStore } from '@/store';
import { CustomerSubscription } from '@/modules/customer/CustomerSubscription';
import AppModal from '@/core/components/AppModal.vue';
import AppFormGroup from '@/core/components/form/AppFormGroup.vue';
import AppInput from '@/core/components/form/AppInput.vue';
import AppButton from '@/core/components/form/AppButton.vue';
import CustomerFormFirstSubscription from './CustomerFormFirstSubscription.vue';

interface CustomerFormSubscriptionFormProps {
	subscription: Partial<CustomerSubscription>;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerFormSubscriptionForm',
  props: {
    subscription: {}
  },
  emits: [
	'cancel',
	'save',
],
  setup(__props: any, { emit: __emit }) {

const { $gettext } = useGettext();
const store = useStore<AppStore>();
const props = __props;
const emit = __emit;
const title = computed<string>(() => (
	props.subscription.id
	? $gettext('Redigera abonnemang')
	: $gettext('Nytt abonnemang')
));
const data = ref<Partial<CustomerSubscription>>({});

onBeforeMount(async () => {
	data.value = Object.assign({}, props.subscription);
	await store.dispatch('loadProducts');
});

const cancel = () => {
	emit('cancel');
};

const save = () => {
	emit('save', data.value);
};

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!

  return (_openBlock(), _createBlock(AppModal, {
    onClose: cancel,
    footer: false
  }, {
    header: _withCtx(() => [
      _createElementVNode("h1", null, _toDisplayString(title.value), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _withModifiers(save, ["prevent"])
      }, [
        _createVNode(CustomerFormFirstSubscription, {
          subscription: data.value,
          "onUpdate:subscription": _cache[0] || (_cache[0] = ($event: any) => ((data).value = $event)),
          errors: {},
          "include-addons": ""
        }, null, 8, ["subscription"]),
        _createVNode(AppFormGroup, {
          id: "subscription_valid_from",
          label: _unref($gettext)('Giltig från och med')
        }, {
          default: _withCtx(() => [
            _createVNode(AppInput, {
              type: "date",
              id: "subscription_valid_from",
              modelValue: data.value.valid_from,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.value.valid_from) = $event)),
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        (data.value.id)
          ? (_openBlock(), _createBlock(AppFormGroup, {
              key: 0,
              id: "subscription_valid_to",
              label: _unref($gettext)('Giltig till (kl 00:00)')
            }, {
              default: _withCtx(() => [
                _createVNode(AppInput, {
                  type: "date",
                  id: "subscription_valid_to",
                  modelValue: data.value.valid_to,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.value.valid_to) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createElementVNode("p", null, [
          _createVNode(AppButton, { type: "submit" }, {
            default: _withCtx(() => [
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("Spara", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(AppButton, {
            onClick: cancel,
            class: "t-neutral"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("Avbryt", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ], 32)
    ]),
    _: 1
  }))
}
}

})